<template>
  <div class="home">
  
    
    <!-- 产品信息模块 -->
    <div class="module-section">
      <ProductInfo :batch="batch" />
    </div>
    
    <!-- 主体信息模块 -->
    <div class="module-section">
      <SubjectInfo :batch="batch" />
    </div>
    
    <!-- 品质溯源模块 -->
    <div class="module-section">
      <QualityTrace :batch="batch" @modal-open="handleModalOpen" />
    </div>
    
    <!-- 检测报告模块 -->
    <div class="module-section">
      <TestReport :batch="batch" @modal-open="handleModalOpen" />
    </div>
    
    <!-- 产地信息模块 -->
    <div class="module-section">
      <OriginInfo :batch="batch" />
    </div>
    
    <!-- 底部导航 -->
    <div class="bottom-nav">
      <div 
        v-for="navItem in navItems" 
        :key="navItem.id"
        class="nav-item"
        :class="{ 'active': activeNav === navItem.id }"
        @click="scrollToSection(navItem.id)"
      >
        <div class="nav-item-icon"><img :src="activeNav === navItem.id ? navItem.icon : navItem.gray_icon" alt=""></div>
        <div class="nav-item-text">{{ navItem.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductInfo from '@/components/ProductInfo'
import SubjectInfo from '@/components/SubjectInfo'
import QualityTrace from '@/components/QualityTrace'
import TestReport from '@/components/TestReport'
import OriginInfo from '@/components/OriginInfo'

export default {
  name: 'HomeView',
  components: {
    ProductInfo,
    SubjectInfo,
    QualityTrace,
    TestReport,
    OriginInfo
  },
  data() {
    return {
      batch: '',
      navItems: [
        { id: 'product-info', icon: 'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112407A002.png',gray_icon:'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112424A004.png', text: '产品信息' },
        { id: 'subject-info', icon: 'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112440A005.png',gray_icon:'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112453A008.png', text: '主体信息' },
        { id: 'quality-trace', icon: 'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112508A009.png',gray_icon:'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112524A010.png', text: '品质溯源' },
        { id: 'test-report', icon: 'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112538A011.png',gray_icon:'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112549A012.png', text: '检测报告' },
        { id: 'origin-info', icon: 'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112559A013.png',gray_icon:'https://suyuan.yueshan2026.cn//profile/upload/2026/01/20/20260120112613A014.png', text: '产地信息' }
      ],
      activeNav: 'product-info',
      isModalOpen: false
    }
  },
  created() {
    // 获取 URL 中的 batch 参数
    this.getBatchParam();
  },
  mounted() {
    // 添加滚动事件监听
    window.addEventListener('scroll', this.updateActiveNav)
  },
  watch: {
    // 监听弹窗状态变化，控制页面滚动
    isModalOpen(newVal) {
      if (newVal) {
        this.preventScroll();
      } else {
        this.allowScroll();
      }
    }
  },
  methods: {
    // 禁止页面滚动
    preventScroll() {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    },
    
    // 允许页面滚动
    allowScroll() {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    },
    
    // 获取 URL 中的 batch 参数
    getBatchParam() {
      const urlParams = new URLSearchParams(window.location.search);
      this.batch = urlParams.get('batch') || '';
      console.log('获取到的 batch 参数:', this.batch);
    },
    
    // 滚动到指定模块
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
        this.activeNav = sectionId
      }
    },
    
    // 更新当前激活的导航项
    updateActiveNav() {
      // 当弹窗打开时，不更新导航项
      if (this.isModalOpen) return;
      
      const scrollPosition = window.scrollY + 100
      
      // 检查每个模块是否在视图中
      this.navItems.forEach(navItem => {
        const element = document.getElementById(navItem.id)
        if (element) {
          const { offsetTop, offsetHeight } = element
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            this.activeNav = navItem.id
          }
        }
      })
    },
    
    // 处理弹窗打开/关闭事件
    handleModalOpen(isOpen) {
      this.isModalOpen = isOpen
    }
  }
}
</script>

<style >
.home {
  max-width: 100%;
  margin: 0;
  padding: 0;
  /* background-color: #f0f8f0; */

  position: relative;
  min-height: 100vh;
}
.header-title{
  display: flex;
  align-items: center;
  height:22px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #4caf50;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
}

.page-header h1 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

.page-actions {
  display: flex;
  gap: 15px;
}

.action-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
}
.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  /* padding: 15px; */
  /* background-color: #4caf50; */
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding-top:20px;
  margin-bottom:20px;
}

.module-section {
  margin-bottom: 10px;
  /* background-color: #fff; */
  border-radius: 8px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  overflow: hidden;
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-around;
  padding: 5px 0 20px 0;
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 0px 10px;
  color: #999;
  flex: 1;
  transition: all 0.3s ease;
}

.nav-item.active {
  color: #4caf50;
  font-weight: bold;
}

.nav-item-icon {
  font-size: 22px;
  height:28px;
  /* margin-bottom: 5px; */
  transition: transform 0.3s ease;
}

.nav-item.active .nav-item-icon {
  transform: scale(1.1);
}

.nav-item-text {
  font-size: 12px;
  line-height: 1;
}

</style>